import { render, staticRenderFns } from "./InvoiceExpenses.vue?vue&type=template&id=5fffa5b9&"
import script from "./InvoiceExpenses.vue?vue&type=script&lang=js&"
export * from "./InvoiceExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports